/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import styles from "gui/dialog/text.module.css";
import { ButtonOld } from "components/ButtonOld/ButtonOld";
import { Dialog } from "gui/dialog/dialog";
import { DialogProps } from "gui/dialog/dialog";
import { Icon } from "gui/icon/icon";
import cn from "classnames";

export const DialogText: React.FC<
  DialogProps & {
    icon?: string;
  }
> = (props) => {
  return (
    <Dialog {...props} size="sm" className={cn(styles.text, props.className)}>
      <header>
        <h1>
          {props.icon && <Icon icon={props.icon} />}
          {props.label}
        </h1>
      </header>
      {props.children}
      <footer>
        <ButtonOld size="sm" color2 light onClick={props.onDismiss}>
          Close
        </ButtonOld>
      </footer>
    </Dialog>
  );
};
